import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api } from "common";
import moment from "moment/min/moment-with-locales";
import { Avatar } from "@mui/material";
import { colors } from "../components/Theme/WebTheme";
import { SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import { ThemeProvider } from "@mui/material/styles";
import theme from "styles/tableStyle";
import TableStyle from "../components/Table/Style";
import localization from "../components/Table/Localization";

export default function FacialValidations() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const settings = useSelector((state) => state.settingsdata.settings);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const { fetchUsersOnce } = api;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      const pending = staticusers.filter(
        (u) => u.facialStatus === "pending" && u.facialImage
      );
      setData(pending);
      setLoading(false);
    }
  }, [staticusers]);

  const columns = [
    {
      title: "Selfie",
      field: "facialImage",
      editable: "never",
      render: (rowData) =>
        rowData.facialImage ? (
          <Avatar
            src={rowData.facialImage}
            variant="rounded"
            style={{ width: 50, height: 50 }}
          />
        ) : null,
    },
    {
      title: t("name"),
      field: "firstName",
      editable: "never",
      render: (rowData) => `${rowData.firstName || ""} ${rowData.lastName || ""}`,
    },
    { title: t("user_type"), field: "usertype", editable: "never" },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "never",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : t("hidden_demo"),
    },
    {
      title: "Enviada em",
      field: "facialUpdatedAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.facialUpdatedAt
          ? moment(rowData.facialUpdatedAt).format("lll")
          : null,
    },
  ];

  return loading ? (
    <CircularLoading />
  ) : (
    <ThemeProvider theme={theme}>
      <MaterialTable
        title={"Verificação Facial"}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
          fontFamily: FONT_FAMILY,
        }}
        data={data}
        onRowClick={(evt, rowData) => {
          setSelectedRow(rowData.tableData.id);
          navigate(`/facialvalidations/${rowData.id}`);
        }}
        options={{
          pageSize: 10,
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id
                ? colors.ROW_SELECTED
                : colors.WHITE,
          }),
          ...TableStyle(),
        }}
        localization={localization(t)}
      />
    </ThemeProvider>
  );
}
